import React from 'react';
import { connect } from 'react-redux';
import { Menu, Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';


import * as actions from '../../actions/user';

const fundRaiserMenu = (history) => (
  <Menu>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/starting_fund')} style={{ color: 'black' }}>
        Start Fundraising
      </Button>
    </Menu.Item>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/school')} style={{ color: 'black' }}>
        Schools
      </Button>
    </Menu.Item>
    <Menu.Item style={{ padding: 0 }}>
      <Button onClick={() => history.push('/event-manager')} type='link' style={{ color: 'black' }}>
        Create an Event
      </Button>
    </Menu.Item>
  </Menu>
);

const howItWorksMenu = (history) => (
  <Menu>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/guarantee')} style={{ color: 'black' }}>
        iCause Guarantee
      </Button>
    </Menu.Item>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/why-icause')} style={{ color: 'black' }}>
        Why Icause?
      </Button>
    </Menu.Item>
  </Menu>
);

const donateForMenu = (history) => (
  <Menu>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/starting_fund')} style={{ color: 'black' }}>
        Health & Medical
      </Button>
    </Menu.Item>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/starting_fund')} style={{ color: 'black' }}>
        Pets & Animals
      </Button>
    </Menu.Item>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/starting_fund')} style={{ color: 'black' }}>
        Accident
      </Button>
    </Menu.Item>
    <Menu.Item style={{ padding: 0 }}>
      <Button type='link' onClick={() => history.push('/starting_fund')} style={{ color: 'black' }}>
        Bucket List
      </Button>
    </Menu.Item>
  </Menu >
);

const Header = (props) => {
  const { history, user, logout } = props;
  return (
    <div>
      <header id="header">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <div className="container">
            <Button style={{ paddingTop: '0px', marginTop: '-20px' }} onClick={() => history.push('/homepage')} className="navbar-brand" type='link'>
              <img src="/images/logo.png" className="img-fluid" alt="" />
            </Button>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"></span> </button>
            <div style={{ paddingTop: '8px' }} className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto ">
                <li className="nav-item ">
                  <Dropdown overlay={() => fundRaiserMenu(history)}>
                    <a href='dsa' style={{ fontSize: 15, marginRight: 50, color: 'black' }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                      Fundraise <DownOutlined />
                    </a>
                  </Dropdown>
                </li>
                <li className="nav-item">
                  <Dropdown overlay={() => howItWorksMenu(history)}>
                    <a href='dsa' style={{ fontSize: 15, marginRight: 50, color: 'black' }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                      How It Works? <DownOutlined />
                    </a>
                  </Dropdown>
                </li>
                <li className="nav-item">
                </li>
                <li className="nav-item">
                  <Dropdown overlay={() => donateForMenu(history)}>
                    <a href='dsa' style={{ fontSize: 15, marginRight: 30, color: 'black' }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                      Donate For <DownOutlined />
                    </a>
                  </Dropdown>
                </li>
                <li className="nav-item">
                  <Button style={{ paddingTop: '0px', marginTop: '-3px' }} onClick={() => history.push('/blogs')} className="nav-link" type='link'>
                    Blog
                  </Button>
                </li>
              </ul>
              <form className="form-inline my-2 my-lg-0 ml-4">
                <button
                  onClick={() => {
                    if (user && user.id) {
                      logout();
                    } else {
                      history.push('/auth/login')
                    }
                  }}
                  className="btn btn-success my-2 my-sm-0 text-uppercase"
                  type="submit">
                  {user && user.id ? 'Logout' : 'BECOME A MEMBER'}
                </button>
              </form>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default connect(({ user }) => ({ user }), actions)(Header);

